import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { JADHU_SCHEMAS, SeoService } from '../services/seo.service';
import { environment } from '../../../environments/environment';

export const seoResolver: ResolveFn<boolean> = (
  route,
  state
) => {

  const seoService = inject(SeoService);

  const seo = route.data?.['seo'];

  if (!seo) {
    return true;
  }

  const breadcrumbSchema = seo.breadcrumbs
      ? JADHU_SCHEMAS.breadcrumb(seo.breadcrumbs) : null;

  seoService.setPage({
    ...seo,
    schema: [
      ...(seo.schema || []),

      ...(breadcrumbSchema
        ? [breadcrumbSchema]
        : [])
    ],
    ogTitle: seo.ogTitle ?? seo.title,
    ogDescription: seo.ogDescription ?? seo.description,
    ogUrl: seo.ogUrl ?? `${environment.websiteUrl}${state.url}`,
    canonicalUrl: seo.canonicalUrl ?? `${environment.websiteUrl}${state.url}`
  });

  seoService.setHreflang(state.url);

  return true;
};
